import React, { useState } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Confirm, Message, Loader } from 'semantic-ui-react';

import AddButton from '../../components/Button/AddButton';
import Table from '../../components/Table';
import Modal from './Modal';

import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import { Container, Header, Title } from './styles';

import { GET_MOTIVES } from '../../services/graphql/queries';
import { DELETE_MOTIVE } from '../../services/graphql/mutations';

const columns = [
  { id: 'motive', label: 'Motivo', minWidth: 100 },
  { id: 'creation_date', label: 'Fecha de Creación', minWidth: 100 },
  { id: 'active', label: 'Activo', minWidth: 100 },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

export default function Motives() {
  const [open, setOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [recordId, setRecordId] = useState(null);

  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState({});

  const { loading, error, data, refetch } = useQuery(GET_MOTIVES);
  const [deleteMotive] = useMutation(DELETE_MOTIVE);

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleOnDeleteClick(id) {
    setRecordId(id);
    setConfirmationOpen(true);
  }

  async function handleDelete() {
    setConfirmationOpen(false);
    await deleteMotive({ variables: { id: recordId } });
    refetch();
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  return (
    <Container data-testid="motives-component">
      <Confirm
        data-testid="confirm-component"
        open={confirmationOpen}
        onCancel={() => setConfirmationOpen(false)}
        onConfirm={handleDelete}
        cancelButton="No"
        confirmButton="Si"
        header="Eliminar registro"
        content="¿Estás seguro de que deseas eliminar este registro?"
      />
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Motivos</Title>
            <AddButton add onClick={handleAdd} />
          </Header>

          {loading && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}

          {!loading && !error && data && (
            <Table
              data-testid="table"
              data={data ? data.getMotives : null}
              columns={columns}
              handleEdit={handleEdit}
              handleDelete={handleOnDeleteClick}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            edit={edit}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
